// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"548":"885e0604","672":"6a497a74","739":"fbd251e2"}[chunkId] + ".chunk.js";
};